import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function MessageIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 18 17"
        {...props}
      >
        <path
          stroke="#503291"
          strokeLinecap="round"
          strokeWidth={1.25}
          d="M3.821 1.5C2.54 1.5 1.5 2.587 1.5 3.927v6.001c0 1.34 1.04 2.427 2.321 2.427h.258l.635 2.145 2.312-2.145h7.153c1.282 0 2.321-1.086 2.321-2.427V3.927c0-1.34-1.04-2.427-2.321-2.427z"
        />
      </svg>
    </Icon>
  )
}
export default MessageIcon
